function includeScript( url, callback, id ) {
  if (id && document.getElementById(id)) {
    // Make sure we only load this script once but
    // call the callback every time
    callback()
    return 
  }
  let documentTag = document,
    tag = 'script',
    object = documentTag.createElement(tag),
    scriptTag = documentTag.getElementsByTagName(tag)[0];
  object.src = '//' + url;
  object.id = id
  if (callback) {
    object.addEventListener('load', (e) => {
      callback(null, e);
    }, false);
  }
  scriptTag.parentNode.insertBefore(object, scriptTag);
}

export { includeScript }
